@if (!identityResolved) {
  <div class="px-12 py-8 text-xs text-secondary-text">Loading workspaces…</div>
} @else if (!currentTeamWorkspace) {
  <app-sidebar-item
    class="rounded [&:not(.drag-over)]:hover:bg-hover"
    *nestedFor="
      let item of items;
      let index = index;
      let depth = depth;
      let expandable = expandable;
      let expanded = expanded;
      stateKey: StateKey.filesSidebarFoldersTree + team?.id
    "
    [title]="item.title"
    [icon]="item.icon"
    [depth]="depth + (team ? 2 : 0)"
    [expandable]="expandable"
    [expanded]="expanded.value"
    [active]="currentTeamId === team?.id && sidebarFilter === item.id"
    (onExpand)="expanded.next($event)"
    (appClick)="selectFilter(item.id)"
    [appSidebarContextMenu]="item.id"
    [appSidebarContextMenuTenantId]="team?.id"
    #elRef
    appDroppable
    appDroppableHoverClass="drag-over"
    [appDroppablePredicate]="dndPredicate"
    (appDroppableDrop)="dndDrop($event, item.id, index, team)"
  />

  <app-sidebar-items-divider />
  <app-side-bar-folders (selectFilter)="selectFilter($event)" [team]="team" />
} @else {
  @if (currentMemberTenant) {
    <section class="rail-section">
      <button
        type="button"
        class="rail-section-heading"
        [attr.aria-expanded]="myWorkspaceExpanded()"
        (click)="myWorkspaceExpanded.set(!myWorkspaceExpanded())"
      >
        <app-icon name="sapphire-chevron-right" size="s" [class.rotate-90]="myWorkspaceExpanded()" />
        My Workspace
      </button>

      @if (myWorkspaceExpanded()) {
        <div class="rail-section-content">
          @for (item of primaryItems; track item.id; let index = $index) {
            <ng-container
              [ngTemplateOutlet]="navigationItem"
              [ngTemplateOutletContext]="{ item: item, index: index, team: currentMemberTenant }"
            />
          }

          <button
            type="button"
            class="rail-view-more"
            [attr.aria-expanded]="moreExpanded()"
            (click)="moreExpanded.set(!moreExpanded())"
          >
            <app-icon name="sapphire-chevron-right" size="s" [class.rotate-90]="moreExpanded()" />
            {{ moreExpanded() ? 'Show less' : 'View more' }}
          </button>

          @if (moreExpanded()) {
            @for (item of moreItems; track item.id; let index = $index) {
              <ng-container
                [ngTemplateOutlet]="navigationItem"
                [ngTemplateOutletContext]="{
                  item: item,
                  index: index + primaryItems.length,
                  team: currentMemberTenant,
                }"
              />
              @if (item.id === 'snoozed') {
                <app-sidebar-item [title]="'Following'" icon="bell" [comingSoon]="true" [depth]="0" />
              }
            }
          }

          <div class="rail-item-divider"></div>

          <app-side-bar-folders
            [depth]="0"
            [tenantId]="currentMemberTenant.id"
            (selectFilter)="selectFilter($event, currentMemberTenant)"
            [team]="currentMemberTenant"
          />

          <div class="rail-item-divider"></div>

          <app-knowledge-items-rail
            [prototypeRows]="true"
            [sidebarSplitViewKey]="sidebarSplitViewKey"
            [tenantId]="currentMemberTenant.id"
            [team]="currentMemberTenant"
            [rowHeight]="32"
          />
        </div>
      }
    </section>

    <div class="rail-divider"></div>
  }

  <app-sidebar-shared-placeholder [rows]="sharedItems" [rowHeight]="32" />
  <div class="rail-divider"></div>

  <section class="rail-section">
    <button
      type="button"
      class="rail-section-heading"
      [attr.aria-expanded]="teamWorkspaceExpanded()"
      (click)="teamWorkspaceExpanded.set(!teamWorkspaceExpanded())"
    >
      <app-icon name="sapphire-chevron-right" size="s" [class.rotate-90]="teamWorkspaceExpanded()" />
      Team Workspace
    </button>

    @if (teamWorkspaceExpanded()) {
      <div class="rail-section-content">
        <button
          type="button"
          class="rail-workspace-row"
          [attr.aria-expanded]="currentTeamWorkspaceExpanded()"
          (click)="toggleCurrentTeamWorkspace()"
        >
          <app-icon name="sapphire-chevron-right" size="s" [class.rotate-90]="currentTeamWorkspaceExpanded()" />
          <span
            class="rail-workspace-avatar"
            [style.background-color]="workspaceColor(currentTeamWorkspace)"
            [style.color]="currentTeamWorkspace.color ? null : workspacePalette(currentTeamWorkspace).text"
          >
            {{ currentTeamWorkspaceInitials }}
          </span>
          <span class="rail-workspace-title">{{ currentTeamWorkspace.title }}</span>
        </button>

        @if (currentTeamWorkspaceExpanded()) {
          <div class="rail-team-workspace-content">
            @for (item of teamPrimaryItems; track item.id; let index = $index) {
              <ng-container
                [ngTemplateOutlet]="navigationItem"
                [ngTemplateOutletContext]="{ item: item, index: index, team: currentTeamTenant }"
              />

              @if (index === 0) {
                <app-sidebar-item
                  data-testid="rail-row-assigned-to-me"
                  data-filter="assigned_to_me"
                  class="rail-navigation-item rounded"
                  [title]="'Assigned to me'"
                  icon="sapphire-user-plus"
                  [depth]="0"
                  [active]="
                    (currentTeamId ?? null) === (currentTeamTenant?.id ?? null) && sidebarFilter === 'assigned_to_me'
                  "
                  (appClick)="selectFilter('assigned_to_me', currentTeamTenant)"
                  [appSidebarContextMenu]="'assigned_to_me'"
                  [appSidebarContextMenuTenantId]="currentTeamTenant?.id"
                />
              }
            }

            <button
              type="button"
              class="rail-view-more"
              [attr.aria-expanded]="teamMoreExpanded()"
              (click)="teamMoreExpanded.set(!teamMoreExpanded())"
            >
              <app-icon name="sapphire-chevron-right" size="s" [class.rotate-90]="teamMoreExpanded()" />
              {{ teamMoreExpanded() ? 'Show less' : 'View more' }}
            </button>

            @if (teamMoreExpanded()) {
              @for (item of moreItems; track item.id; let index = $index) {
                <ng-container
                  [ngTemplateOutlet]="navigationItem"
                  [ngTemplateOutletContext]="{
                    item: item,
                    index: index + teamPrimaryItems.length,
                    team: currentTeamTenant,
                  }"
                />
                @if (item.id === 'snoozed') {
                  <app-sidebar-item
                    data-filter="following"
                    [title]="'Following'"
                    icon="bell"
                    [depth]="0"
                    [active]="currentTeamId === currentTeamTenant?.id && sidebarFilter === 'following'"
                    (appClick)="selectFilter('following', currentTeamTenant)"
                    [appSidebarContextMenu]="'following'"
                    [appSidebarContextMenuTenantId]="currentTeamTenant?.id"
                  />
                }
              }
            }
          </div>
        }

        <div class="rail-item-divider"></div>

        <app-side-bar-folders
          title="Team Folders"
          [depth]="0"
          [tenantId]="currentTeamWorkspace.id"
          (selectFilter)="selectFilter($event, currentTeamTenant)"
          [team]="currentTeamTenant"
        />

        <div class="rail-item-divider"></div>

        <app-knowledge-items-rail
          knotsTitle="Team Knots"
          tagsTitle="Team Tags"
          [sidebarSplitViewKey]="sidebarSplitViewKey"
          [tenantId]="currentTeamWorkspace.id"
          [team]="currentTeamTenant"
          [rowHeight]="32"
        />
      </div>
    }
  </section>
}

@if (identityResolved && !currentTeamWorkspace) {
  <app-sidebar-items-divider />
  <!-- Personal workspace: Pinned Knots · Pinned Tags · Pinned Connections, as Notes (Johanna, 2026-10-21). -->
  <app-knowledge-items-rail [sidebarSplitViewKey]="sidebarSplitViewKey" [tenantId]="currentTeamId" [team]="team" />
}

<ng-template #navigationItem let-item="item" let-index="index" let-team="team">
  <app-sidebar-item
    data-testid="rail-row"
    [attr.data-filter]="item.id"
    [attr.data-tenant]="team === currentTeamTenant ? 'team' : 'member'"
    class="rail-navigation-item rounded [&:not(.drag-over)]:hover:bg-hover"
    [title]="item.title"
    [icon]="item.icon"
    [depth]="0"
    [active]="(currentTeamId ?? null) === (team?.id ?? null) && sidebarFilter === item.id"
    (appClick)="selectFilter(item.id, team)"
    [appSidebarContextMenu]="item.id"
    [appSidebarContextMenuTenantId]="team?.id"
    #elRef
    appDroppable
    appDroppableHoverClass="drag-over"
    [appDroppablePredicate]="dndPredicate"
    (appDroppableDrop)="dndDrop($event, item.id, index, team)"
  />
</ng-template>

<ng-template #afterDropTemplate let-item="item">
  <app-file-quick-form
    [autofocus]="true"
    [showMore]="true"
    [title]="item.title"
    [file]="item"
    (more)="handleMore($event)"
    (close)="handleClose()"
    [transferredDraft]="true"
  />
</ng-template>
